/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type ViewerFeatureFlagsQueryVariables = Exact<{
  keys: Array<Types.Scalars['NonEmptyString']['input']>;
}>;


export type ViewerFeatureFlagsQuery = { viewer: { featureFlags: Array<{ key: Types.Scalars['NonEmptyString']['output'], value: Types.Scalars['String']['output'] | null }> | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ViewerFeatureFlagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ViewerFeatureFlags($keys: [NonEmptyString!]!) {
  viewer {
    featureFlags(keys: $keys) {
      key
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>;